import i18next from 'i18next';
import {
  currentDayMinutes,
  currentUtcMillis,
  formatDayMinutes,
  getWeekDay,
} from '../../../utils/dateHelpers';

export const getDayOptions = ({ deliveryRestaurant, isTakeAway }) => {
  const { workTimes } = deliveryRestaurant;
  if (!workTimes || workTimes.length === 0) {
    return [];
  }

  const options = [];

  const currentWeekDay = getWeekDay(deliveryRestaurant.data.timeZone);
  for (let i = 0; i < 7; i += 1) {
    if (i === 0) {
      const anyTimesAvailableToday =
        getTimeOptions({ deliveryDayDelta: 0, deliveryRestaurant, isTakeAway }).length > 0;
      if (!anyTimesAvailableToday) {
        continue;
      }
    }

    let dayToCheck = currentWeekDay + i;
    if (dayToCheck > 7) {
      dayToCheck -= 7;
    }

    const dayWorkTime = workTimes.find((x) => x.day === dayToCheck);

    if (dayWorkTime) {
      if (i === 0) {
        options.push({ label: i18next.t('delivery:days.today'), value: i });
      } else if (i === 1) {
        options.push({ label: i18next.t('delivery:days.tomorrow'), value: i });
      } else {
        options.push({ label: i18next.t(`delivery:days.day-${dayToCheck}`), value: i });
      }
    }
  }

  return options;
};

export const getTimeOptions = ({ deliveryRestaurant, deliveryDayDelta, isTakeAway }) => {
  const { workTimes } = deliveryRestaurant;
  if (!workTimes || workTimes.length === 0) {
    return [];
  }

  const options = [];

  const currentWeekDay = getWeekDay(deliveryRestaurant.data.timeZone);
  let selectedWeekDay = currentWeekDay + deliveryDayDelta;
  if (selectedWeekDay > 7) {
    selectedWeekDay -= 7;
  }

  const dayWorkTime = workTimes.find((x) => x.day === selectedWeekDay);

  if (dayWorkTime) {
    const firstPossibleTime = isTakeAway ? dayWorkTime.from + 30 : dayWorkTime.from + 45;
    const lastPossibleTime = isTakeAway ? dayWorkTime.until - 15 : dayWorkTime.until;

    const currentMinutes = currentDayMinutes(deliveryRestaurant.data.timeZone);

    for (let i = firstPossibleTime; i <= lastPossibleTime; i += 15) {
      if (deliveryDayDelta === 0 && currentMinutes + (isTakeAway ? 40 : 60) > i) {
        continue;
      }

      options.push({ label: formatDayMinutes(i), value: i });
    }
  }

  return options;
};

export const getDeliveryDateOnDeliverNow = ({ deliveryRestaurant, isTakeAway }) => {
  let minutesToAdd = 0;

  if (isTakeAway) {
    if (deliveryRestaurant.takeawayNowMax > 0) {
      minutesToAdd = deliveryRestaurant.takeawayNowMax;
    } else {
      minutesToAdd = 40;
    }
  } else if (deliveryRestaurant.deliveryNowMax > 0) {
    minutesToAdd = deliveryRestaurant.deliveryNowMax;
  } else {
    minutesToAdd = 60;
  }

  // Additional 2 minutes for order payment
  const deliveryDateUtc = currentUtcMillis() + minutesToAdd * 60000 + 2 * 60000;

  return deliveryDateUtc;
};
